import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { H4 } from 'foundations-components/transitional/components/H4';
// @ts-expect-error module not typed
import { getSelectorForModuleByName } from 'InpageEditorUI/lib/dom';
import { useDispatch } from 'react-redux';
// @ts-expect-error module not typed
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
// @ts-expect-error module not typed
import { updateScrollToModuleId } from 'ContentEditorUI/redux/actions/inpageActions';
// @ts-expect-error Untyped module.
import { trackInpageUsageEvent } from '../../eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error Untyped module.
import { useBus } from '../../context/Bus';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CASE_STUDY_ONBOARDING_TOUR_KEY = 'CASE_STUDY_ONBOARDING';
export const CASE_STUDY_ONBOARDING_TOUR_STEPS = {
  TITLE: 'TITLE',
  FEATURE: 'FEATURE',
  FEATURE_SIDE_PANEL: 'FEATURE_SIDE_PANEL',
  METRICS: 'METRICS',
  METRICS_SIDE_PANEL: 'METRICS_SIDE_PANEL',
  PAGE_CONTENTS: 'PAGE_CONTENTS',
  URL: 'URL',
  META_DESCRIPTION: 'META_DESCRIPTION',
  PUBLISH: 'PUBLISH'
};
const CaseStudyOnboardingInpageModuleTourStep = ({
  widget,
  step,
  header,
  body,
  children
}) => {
  const bus = useBus();
  const dispatch = useDispatch();
  const attachTo = getSelectorForModuleByName(widget.name);
  const handleBeforeNext = useCallback(({
    stepKey
  }) => {
    bus.dispatchActionToEventBus(trackInpageUsageEvent({
      action: 'Case Study Onboarding',
      event: 'completedOnboardingTourStep',
      subscreen: stepKey
    }));
    // Communicate with the parent tour that this is the module to select
    // Because the next tour step is opening up the Edit Module side panel with contents of this module
    dispatch(updateSelectedItem(widget.name));
  }, [bus, dispatch, widget.name]);
  const handleBeforeStart = useCallback(() => {
    dispatch(updateScrollToModuleId(widget.name));
  }, [dispatch, widget.name]);
  return /*#__PURE__*/_jsx(UITourStep, {
    stepKey: step,
    tourKey: CASE_STUDY_ONBOARDING_TOUR_KEY,
    showCloseButton: true,
    attachTo: attachTo,
    showSteps: true,
    width: 420,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: header
      }),
      body: /*#__PURE__*/_jsx("p", {
        children: body
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UITourBackButton, {}), /*#__PURE__*/_jsx(UITourNextButton, {
          use: "primary",
          beforeNext: handleBeforeNext
        })]
      })
    },
    pulser: {
      attachTo
    },
    beforeStart: handleBeforeStart,
    children: children
  });
};
export const CaseStudyOnboardingTourStepFeature = ({
  widget,
  children
}) => {
  return /*#__PURE__*/_jsx(CaseStudyOnboardingInpageModuleTourStep, {
    step: CASE_STUDY_ONBOARDING_TOUR_STEPS.FEATURE,
    widget: widget,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyOnboardingTour.step.feature.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyOnboardingTour.step.feature.body"
    }),
    children: children
  });
};
export const CaseStudyOnboardingTourStepMetrics = ({
  widget,
  children
}) => {
  return /*#__PURE__*/_jsx(CaseStudyOnboardingInpageModuleTourStep, {
    step: CASE_STUDY_ONBOARDING_TOUR_STEPS.METRICS,
    widget: widget,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyOnboardingTour.step.metrics.header"
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "caseStudyOnboardingTour.step.metrics.body"
    }),
    children: children
  });
};